// Build damgası: /version.json (public/) canlı build'i saniyeler içinde
// doğrulamak için; UI'da Ayarlar > Sürüm satırında gösterilir.
import { useEffect, useState } from "react";

export function useBuildMarker() {
  const [marker, setMarker] = useState("yükleniyor…");
  useEffect(() => {
    fetch("/version.json", { cache: "no-store" })
      .then((r) => r.json())
      .then((d) => setMarker(d.marker || "bilinmiyor"))
      .catch(() => setMarker("bilinmiyor"));
  }, []);
  return marker;
}
